import Form from 'react-bootstrap/Form';
import { CheckTypeEnum } from 'components/filtering/types/CheckTypeEnum';



interface CheckboxToggleAllProps {
	valuesCheckType: CheckTypeEnum,
	onClick: () => void,
}


const CheckboxToggleAll = (props: CheckboxToggleAllProps) => {
	const { valuesCheckType, onClick } = props;

	return (
		<div className={`popover-filter-result-item toggle-all-item ${valuesCheckType === CheckTypeEnum.some ? ' some-check-type' : ''}`} onClick={onClick}>
			
			<Form.Check
				type="checkbox"
				className="app-form-checkbox"
				checked={valuesCheckType === CheckTypeEnum.none ? false : true}
				onChange={() => {}} />

			<p>Vybrat všechny</p>

		</div>
	);
};

export default CheckboxToggleAll;